import DonorProfileCardTabs from 'modules/donor/components/DonorProfileCardTabs';
import ProfileSideMenuWrapper from 'modules/navigation/components/ProfileSideMenuWrapper';
import { FC } from 'react';
import { useParams } from 'react-router-dom';

const DonorCommunicationsPage: FC = () => {
  const params = useParams();
  const id = params.id || '';

  return (
    <ProfileSideMenuWrapper title="Communications">
      <DonorProfileCardTabs donorId={id} />
    </ProfileSideMenuWrapper>
  );
};
export default DonorCommunicationsPage;
